import styled from 'styled-components/macro';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { copyFor } from '../../copy/copy';
import ThemeContext from '../../utils/theming';

import { ThumbnailLoadingSpinner } from '../LoadingSpinner';

const ImgContainer = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border: ${props => (props.imageReady ? null : '1px solid #d8d8d8')};
    border-radius: 4px;

    .oval,
    .triangle {
        cursor: ${props => (props.imageReady ? 'pointer' : 'default')};
    }

    img {
        opacity: ${props => (props.imageReady ? 1 : 0)};
        object-fit: contain;
        width: 120px;
        height: 120px;
        background-color: #d8d8d8;
        border-radius: 4px;
        cursor: ${props => (props.imageReady ? 'pointer' : 'default')};
    }

    .oval {
        opacity: ${props => (props.imageReady ? 1 : 0)};
        position: absolute;
        width: 32px;
        height: 32px;
        background: ${({ theme }) => theme.colors.primary};
        border-radius: 100%;
    }

    .triangle {
        opacity: ${props => (props.imageReady ? 1 : 0)};
        position: absolute;
        border: solid 1px #ffffff;
        box-sizing: border-box;
        border-width: 6px 0 6px 10px;
        border-color: transparent transparent transparent #ffffff;
        margin-left: 2px;
    }

    .oval,
    .triangle {
        transition: transform 0.6s ease-in-out;
    }

    &:hover .triangle,
    &:hover .oval {
        transform: scale(1.25);
    }
`;

export default props => {
    const thumbnailRef = useRef(null);
    const [imageReady, setImageReady] = useState(false);

    useEffect(() => {
        if (!thumbnailRef.current || !thumbnailRef.current.naturalWidth > 0) {
            let loadImageInterval = setInterval(() => {
                if (thumbnailRef.current) {
                    if (thumbnailRef.current.naturalWidth > 0) {
                        setImageReady(true);
                        clearInterval(loadImageInterval);
                    } else {
                        const randomString = '?random=' + Date.now();
                        thumbnailRef.current.src = props.src + randomString;
                    }
                }
            }, 500);
        } else setImageReady(true);
    }, []);

    props.setVideoIsReady && props.setVideoIsReady(imageReady);

    return (
        <div>
            <ImgContainer
                href={imageReady ? props.href : null}
                target="_blank"
                imageReady={imageReady}
                theme={useContext(ThemeContext)} 
            >
                <img src={props.src} ref={thumbnailRef} alt={copyFor('postRecord','replayVideo','recordvideo')} />
                <div className="oval"></div>
                <div className="triangle"></div>
                {!imageReady && <ThumbnailLoadingSpinner />}
            </ImgContainer>
        </div>
    );
};
